import { type GetListParams, type QueryFunctionContext } from "react-admin";

import { queryClient } from "@/constants/queryClient";
import { LIST_QUERY_KEY } from "@/utils/query";

type ListParams = GetListParams & QueryFunctionContext;

export const getListQueryData = <T>(resource: string, params: ListParams) => {
  const queryData = queryClient.getQueriesData<T>({
    queryKey: [resource, LIST_QUERY_KEY, params],
    exact: true,
  });

  return queryData.find(([key]) => {
    const params = key[key.length - 1] as GetListParams & QueryFunctionContext;
    const filter = params.filter as Record<string, unknown>;
    return Object.keys(filter).length === 0;
  })?.[1];
};
